module.exports = __webpack_public_path__ + "static/media/signin_background.365ad34f.png";